export default vm => ({
  generalData: [
    {
      text: vm.$t('fields.general.type'),
      value: 'transformerType',
      enumLabelPrefix: 'enums.transformer-type.',
    },
    {
      text: vm.$t('fields.asset.transformer.nominal-potency'),
      value: 'nominalPotency',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.transformer-application'),
      value: 'transformerApplication',
      enumLabelPrefix: 'enums.transformer-application.transformer-',
    },
    {
      text: vm.$t('fields.asset.transformer.higher-voltage'),
      value: 'superiorVoltage',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.lower-voltage'),
      value: 'inferiorVoltage',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.tertiary-voltage'),
      value: 'tertiaryVoltage',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.nominal-chain-higher'),
      value: 'superiorNominalChain',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.nominal-chain-lower'),
      value: 'inferiorNominalChain',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.nominal-chain-tertiary'),
      value: 'tertiaryNominalChain',
      precision: 2,
    },
    {
      text: vm.$t('fields.asset.transformer.has-windings'),
      value: 'withTertiaryWinding',
    },
    {
      text: vm.$t('fields.asset.transformer.number-of-monitored-windings'),
      value: 'numberOfWindingsMonitored',
    },
    {
      text: vm.$t('fields.asset.transformer.voltage-regulation'),
      value: 'tensionRegulation',
      enumLabelPrefix: 'enums.tension-regulation.',
    },
    {
      text: vm.$t('fields.asset.transformer.oil-volume'),
      value: 'oilVolume',
      precision: 1,
    },
    {
      text: vm.$t('fields.asset.transformer.oil-mass'),
      value: 'oilKiloMass',
      precision: 1,
    },
    {
      text: vm.$t('fields.asset.transformer.tank-mass-and-accessories'),
      value: 'reservoirMass',
      precision: 1,
    },
    {
      text: vm.$t('fields.asset.transformer.mass-active-part'),
      value: 'activeSideMass',
      precision: 1,
    },
    {
      text: vm.$t('fields.asset.transformer.total-weight'),
      value: 'totalWeight',
      precision: 1,
    },
    {
      text: vm.$t('fields.asset.transformer.temperature-elevation-class'),
      value: 'elevationClass',
    },
    {
      text: vm.$t('fields.asset.transformer.type-of-insulating-paper'),
      value: 'insulationType',
      enumLabelPrefix: 'enums.insulating-paper-type.',
    },
    {
      text: vm.$t('fields.asset.transformer.oil-type'),
      value: 'oilType',
      enumLabelPrefix: 'enums.oil-type.',
    },
    {
      text: vm.$t('fields.asset.transformer.communicating-oil'),
      value: 'communicatingOilOltcTransformer',
    },
    {
      text: vm.$t('fields.asset.transformer.life-expectancy'),
      value: 'lifespan',
      precision: 0,
    },
    {
      text: vm.$t('fields.asset.transformer.minimum-chain-to-determine-on-state'),
      value: 'minimalChainStatusOn',
      precision: 0,
    },
    {
      text: vm.$t('fields.asset.transformer.ambient-measurement-temperature'),
      value: 'activeAmbientTemperature',
    },
    {
      text: vm.$t('fields.asset.maintenance-history'),
      value: 'transformerMaintenanceHistory',
    },
    {
      text: vm.$t('fields.general.observations'),
      value: 'transformerObservation',
    },
  ],
  losses: {
    general: [
      {
        text: vm.$t('asset-information.asset-info.losses.fields.losses-in-empty'),
        value: 'lossesInEmpty',
        precision: 3,
      },
    ],
    shortCircuitLosses: [
      {
        text: vm.$t('asset-information.asset-info.losses.fields.winding-1'),
        value: 'winding1ShortCircuitLosses',
        precision: 3,
      },
      {
        text: vm.$t('asset-information.asset-info.losses.fields.winding-2'),
        value: 'winding2ShortCircuitLosses',
        precision: 3,
      },
      {
        text: vm.$t('asset-information.asset-info.losses.fields.winding-3'),
        value: 'winding3ShortCircuitLosses',
        precision: 3,
      },
    ],
  },
});
